<div class="analysis-header">
  <button class="back-btn" (click)="backClicked.emit()" aria-label="Zurück zur Übersicht">
    <img [src]="backIconSrc()" alt="" width="44" height="44" />
  </button>

  <div class="title-info">
    @if (stockLogo) {
      <img [src]="stockLogo" alt="" width="24" height="24" class="stock-logo" />
    }
    <span class="title">{{ title }}</span>
    @if (showInfoButton) {
      <app-v3-info-button
        [opensPage]="true"
        (pageClicked)="infoClicked.emit()"
      ></app-v3-info-button>
    }
  </div>

  @if (updatedAt) {
    <app-time-ago class="updated-at" [updatedAt]="updatedAt" format="minimal"></app-time-ago>
  }
</div>
